import { createStore } from "zustand/vanilla";
import { conflict } from "@pack-it-up/shared";
import { errorToMessage } from "../errorToMessage.js";
export const createManagedProfilesStore = (deps) => {
    // Stream subscriptions are owned by the store: dispose() unsubscribes them all, so a
    // superseded store stops writing into state nothing renders. `subs` is filled after
    // the store exists (the streams push into it).
    const subs = [];
    const store = createStore((set, get) => ({
        profiles: [],
        error: null,
        async createProfile(displayName) {
            const r = await deps.managed.createManagedProfile({ displayName });
            if (!r.ok)
                set({ error: errorToMessage(r.error) });
            return r;
        },
        async updateProfile(patch) {
            const r = await deps.managed.updateManagedProfile(patch);
            if (!r.ok)
                set({ error: errorToMessage(r.error) });
            return r;
        },
        async addGuardian(profileId, friendUserId) {
            const r = await deps.managed.addGuardian(profileId, friendUserId);
            if (!r.ok)
                set({ error: errorToMessage(r.error) });
            return r;
        },
        async removeGuardian(profileId, userId) {
            // Doc 04 §7: a managed profile must keep at least one guardian. Enforce
            // client-side before the network so the UI can disable the last "remove".
            const profile = get().profiles.find((p) => p.id === profileId);
            if (profile && profile.guardianUserIds.length <= 1) {
                const reason = "A managed profile needs at least one guardian.";
                set({ error: reason });
                return { ok: false, error: conflict(reason) };
            }
            const r = await deps.managed.removeGuardian(profileId, userId);
            if (!r.ok)
                set({ error: errorToMessage(r.error) });
            return r;
        },
        async upgradeToAccount(profileId, email) {
            const r = await deps.managed.upgradeToAccount(profileId, email);
            if (!r.ok)
                set({ error: errorToMessage(r.error) });
            return r;
        },
        dispose() {
            for (const unsubscribe of subs.splice(0))
                unsubscribe();
        },
    }));
    subs.push(deps.managed.observeMyManagedProfiles(deps.userId).subscribe((profiles) => store.setState({ profiles })));
    return store;
};
//# sourceMappingURL=managedProfilesStore.js.map